import { render, staticRenderFns } from "./DPlayerSettingOptions.vue?vue&type=template&id=5b7829fc&scoped=true&"
import script from "./DPlayerSettingOptions.vue?vue&type=script&lang=js&"
export * from "./DPlayerSettingOptions.vue?vue&type=script&lang=js&"
import style0 from "./DPlayerSettingOptions.vue?vue&type=style&index=0&id=5b7829fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7829fc",
  null
  
)

export default component.exports